new Tobi({
	captions: true,
	closeLabel: 'Bezárás',
	loadingIndicatorLabel: 'Betöltés',
	navLabel: ['Előző', 'Következő'],
	selector: '.js-lightbox',
	zoom: false,
});